import { render, staticRenderFns } from "./PaypalIcon.vue?vue&type=template&id=01512e6e&"
import script from "./PaypalIcon.vue?vue&type=script&lang=js&"
export * from "./PaypalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports